import React from "react";
import { View, StyleSheet } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { useTheme } from "../../../context/ThemeContext";

export const ProductRating = ({ rating, size = 16, showEmpty = true, maxStars = 5 }) => {
	const theme = useTheme();
	const styles = useStyles();

	const renderStars = () => {
		const stars = [];
		const fullStars = Math.floor(rating);
		const hasHalfStar = rating % 1 >= 0.5;

		// Full stars
		for (let i = 0; i < fullStars; i++) {
			stars.push(<Ionicons key={`star-${i}`} name="star" size={size} color={theme.colors.warning} style={styles.star} />);
		}

		// Half star
		if (hasHalfStar) {
			stars.push(<Ionicons key="half-star" name="star-half" size={size} color={theme.colors.warning} style={styles.star} />);
		}

		// Empty stars
		if (showEmpty) {
			const emptyStars = maxStars - fullStars - (hasHalfStar ? 1 : 0);
			for (let i = 0; i < emptyStars; i++) {
				stars.push(<Ionicons key={`empty-star-${i}`} name="star-outline" size={size} color={theme.colors.warning} style={styles.star} />);
			}
		}

		return stars;
	};

	return <View style={styles.container}>{renderStars()}</View>;
};

const useStyles = () => {
	const theme = useTheme();

	return StyleSheet.create({
		container: {
			flexDirection: "row",
			alignItems: "center",
		},
		star: {
			marginRight: 2,
		},
	});
};
